import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import MaterialTable from 'material-table';
import { defaultGridOptions, parseCLDR26, useGridColDefs } from '../../utils/GridUtils';

const useStyles = makeStyles(theme => ({
  shapeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '1em',
  },
  shapeCircle: {
    backgroundColor: 'black',
    width: 15,
    height: 15,
    borderRadius: '50%',
  },
  redCircle: {
    backgroundColor: 'red',
  },
  greenCircle: {
    backgroundColor: 'green',
  },
  blocked: {
    transition: '1s',
    pointerEvents: 'none',
    opacity: 0.5,
  },
}));

const StCell = ({ value }) => {
  const classes = useStyles();
  
  return (
    <div className={classes.shapeContainer}>
      <div className={clsx(classes.shapeCircle, value === 'VERDE' ? classes.greenCircle : classes.redCircle)} />
    </div>
  );
};

const BlockStatus = ({ value , rowData }) => {
  const docCompColumn = rowData.clearingDocument;
  const compensStatus = docCompColumn === "" ?"A VERIFICAR":"COMPENSADO";
  return (value === 'BLOQUEADO' ? compensStatus : value)
};

const PostedBillsGrid = ({ data, tableRef, blockedByDateSelection }) => {
  const classes = useStyles();
  
  const colDefs = useGridColDefs([
    { title: 'ST', field: 'state', valueRender: (value, rowData) => <StCell value={value} /> },
    { title: 'Clase del documento', field: 'docType', brakeWhiteSpaceHeader: true },
    { title: 'Fecha de emisión', field: 'documentDate', valueType: 'date', brakeWhiteSpaceHeader: true },
    { title: 'Referencia', field: 'reference' },
    { title: 'Importe MD', field: 'documentImportMD', currencyRef: 'currency', brakeWhiteSpaceHeader: true },
    { title: 'Importe ML', field: 'localImportMD', currencyRef: 'localCurrency', brakeWhiteSpaceHeader: true },
    { title: 'Fecha de vencimiento', field: 'expirationDate', valueType: 'date', brakeWhiteSpaceHeader: true },
    { title: 'Fecha de pago', field: 'paymentDate', valueType: 'date', brakeWhiteSpaceHeader: true },
    { title: 'Bloqueo de pago', field:'paymentBlock', brakeWhiteSpaceHeader: true, valueRender: (value, rowData) => <BlockStatus value={value} rowData={rowData} />},
    //{ title: 'Saldo', field: 'balance', valueType: 'numeric', valueRender: (value, rowData) => `ARS ${parseCLDR26(value)}` },
    { title: 'Saldo', field: 'balance', currencyRef: 'localCurrency', brakeWhiteSpaceHeader: true },
    { title: 'Doc. Comp', field: 'clearingDocument', brakeWhiteSpaceHeader: true },
    { title: 'Nro. Documento SAP', field: 'docNumberSap', brakeWhiteSpaceHeader: true },
    { title: 'Fe. Contable', field: 'recordDate', valueType: 'date', brakeWhiteSpaceHeader: true },
    { title: 'Medio de pago', field: 'paymentMethod', brakeWhiteSpaceHeader: true },
  ]);

  return (
    <div style={{ width: '100%' }} className={clsx({ [classes.blocked]: blockedByDateSelection })}>
      <MaterialTable
        {...defaultGridOptions}
        options={{
          ...defaultGridOptions.options,
          pageSize: tableRef?.current?.dataManager?.pageSize || defaultGridOptions.options.pageSize,
        }}
        columns={colDefs}
        data={data}
        tableRef={tableRef}
      />
    </div>
  );
};

export default PostedBillsGrid;
